export const CREATOR = {
  USER: 'user',
  AI: 'ai',
} as const;
